__turbopack_context__.v({
  "always-break": "page-module-scss-module__uW7oqq__always-break",
  "break-lg": "page-module-scss-module__uW7oqq__break-lg",
  "info-card-center-value": "page-module-scss-module__uW7oqq__info-card-center-value",
  "live-data-row": "page-module-scss-module__uW7oqq__live-data-row",
  "live-data-row-text": "page-module-scss-module__uW7oqq__live-data-row-text",
  "new-feature-date": "page-module-scss-module__uW7oqq__new-feature-date",
  "new-feature-description": "page-module-scss-module__uW7oqq__new-feature-description",
  "new-feature-description-preview": "page-module-scss-module__uW7oqq__new-feature-description-preview",
  "new-feature-divider": "page-module-scss-module__uW7oqq__new-feature-divider",
  "new-feature-header": "page-module-scss-module__uW7oqq__new-feature-header",
  "new-feature-item": "page-module-scss-module__uW7oqq__new-feature-item",
  "new-feature-link": "page-module-scss-module__uW7oqq__new-feature-link",
  "new-feature-recent-badge": "page-module-scss-module__uW7oqq__new-feature-recent-badge",
  "new-feature-title": "page-module-scss-module__uW7oqq__new-feature-title",
  "new-features-list": "page-module-scss-module__uW7oqq__new-features-list",
  "show-more-button": "page-module-scss-module__uW7oqq__show-more-button",
  "show-more-container": "page-module-scss-module__uW7oqq__show-more-container",
  "todo-alert-wrapper": "page-module-scss-module__uW7oqq__todo-alert-wrapper",
});
